export default "/_next/static/assets/images/logo-blick.87aa6dbe7547d369ffb9775443bc3b55.svg";